import { Injectable } from "@angular/core";
import { InfoFromCisloUjDto } from '../dto/InfoFromCisloUjDto';


/**
 * Pomocná třída pro rozparsování evidenčního čísla uznané jednotky.
**/
@Injectable({
  providedIn: 'root'
})
export class UjParseUtils {
  // konstanty pro parsování dat z čísla UJ - udávají pozici v poli vzniklém po splitu čísla UJ znakem '-'
  private readonly repMaterialKategorie: number = 1;
  private readonly typZdrojeRepMaterialu: number = 2;
  private readonly druhDreviny: number = 3;
  private readonly oblastProvenience: number = 5;
  private readonly vyskovePasmo: number = 6;
  private readonly genovaZakladna: number = 8;

  private readonly validCzPskUjRegex = /CZ-[1234]-(1|2|2A|2B|2C|3|4|5|6)-[a-zA-Z]{2,3}-\d{1,5}-\d{1,2}-\d{1}-(A|B|C|E|H|J|K|L|M|P|S|T|U|V|Z)((-G[0-9a-zA-Z]{1,1}[0-9a-zA-Z-]{0,3}[0-9a-zA-Z]{1,1})|(-G[0-9a-zA-Z]{1,5}))?$/;


  /**
   * Provede kontrolu správnosti CUJ a pokud je ok, rozpársuje jej na jednotlivé složky.
   * @param cuj
   */
  parseUj(cuj: string): InfoFromCisloUjDto {
    let info: InfoFromCisloUjDto = new InfoFromCisloUjDto();

    let regExpCzUj = new RegExp(this.validCzPskUjRegex);
    info.isValidCzCisloUj = regExpCzUj.test(cuj);

    if (info.isValidCzCisloUj) {
      var splittedUj = cuj.split('-');
      info.oblastProvenience = splittedUj[this.oblastProvenience];
      info.repMaterialKategorie = Number(splittedUj[this.repMaterialKategorie]);
      info.typZdrojeRepMaterialu = splittedUj[this.typZdrojeRepMaterialu];
      info.vyskovePasmo = Number(splittedUj[this.vyskovePasmo]);
      info.druhDreviny = splittedUj[this.druhDreviny];
      info.genovaZakladna = splittedUj.length == 9 ? splittedUj[this.genovaZakladna] : '';
    }
    return info;
  }
}
